<template>
  <div
    v-if="!hideOverlay"
    class="vadResponsiveMessages">
    <!-- SCREEN TOO SMALL ERROR -->
    <div
      v-if="displayInsuficientResolutionPage"
      class="has-text-centered">
      <div class="title is-3 is-margin-bottom">
        <div
          v-if="displayInsuficientResolutionPage"
          class="vadResponsiveMessages-mobile">
          Oups !
        </div>
        <div class="vadResponsiveMessages-tablette">
          Oups !
        </div>
        <div class="vadResponsiveMessages-desktop">
          Oups !
        </div>
      </div>

      <video
        width="100%"
        muted
        autoplay
        loop
        playsinline
        class="is-margin-bottom"
        id="video">
        <source
          src="/video/responsive-house.mp4"
          type="video/mp4">
      </video>

      <div class="title is-3 has-text-weight-bold is-margin-bottom">
        <div
          v-if="displayInsuficientResolutionPage"
          class="vadResponsiveMessages-mobile">
          Résolution d’affichage insuffisante.
        </div>
        <div class="vadResponsiveMessages-tablette">
          Résolution d’affichage insuffisante.
        </div>
        <div class="vadResponsiveMessages-desktop">
          Résolution d’affichage insuffisante.
        </div>
      </div>

      <div class="is-size-5 has-text-weight-light is-margin-bottom">
        <div>
          La résolution d’affichage n’est pas suffisante pour afficher
          correctement les informations. Veuillez agrandir la fenêtre de votre navigateur.
        </div>
      </div>

      <div class="">
        <div class="vadResponsiveMessages-mobile">
          <!-- <a
            :href="getStoreLink"
            class="button is-primary">Rejoindre la version mobile</a> -->
        </div>
        <div class="vadResponsiveMessages-tablette">
          <!-- <a
            :href="getStoreLink"
            class="button is-primary">Rejoindre la version mobile</a> -->
        </div>
        <div class="vadResponsiveMessages-desktop"></div>
      </div>
    </div>
    <!-- MOBILE DOWNLOAD APP LANDING PAGE  -->
    <div
      v-else
      class="has-text-centered vadResponsiveMessages-mobile">
      <!-- Spécial pour les mobiles-->

      <div class="vadResponsiveMessages--mobile-cover">
      </div>

      <div class="vadResponsiveMessages--mobile-logo">
        <div class="wrap">
          <img
            src="/img/vadimm/vadimm-logo--big--dark@2x.png"
            class="image w100"
            alt="">
        </div>
      </div>

      <div class="vadResponsiveMessages--mobile-openApplication">
        <div class="wrap">
          <a
            :href="getStoreLink"
            class="button is-info is-padding-right is-padding-left">
            <span>Utiliser l'application</span>
            <!-- <span>Télécharger l'application</span> -->
          </a>
        </div>
      </div>

      <div class="vadResponsiveMessages--mobile-store">
        <div class="wrap">
          <!-- <div class="title is-3 has-text-black has-text-weight-normal is-margin-bottom-xsmall">
            Vous n'avez pas l'application
          </div> -->
          <div class="title is-5 has-text-black has-text-weight-normal">
            Collaborez où que vous soyez
          </div>
          <div class="columns is-mobile is-vcentered is-centered">
            <div
              v-if="getMobileOperatingSystem() === 'iOS'"
              class="column is-half">
              <a
                :href="mobileLinks.appHomePageIosLink"
                class="is-block"><img
                  src="/img/download-app-store.png"
                  class="is-block"
                  alt="Télécharger sur l'App Store"></a>
            </div>
            <div
              v-if="getMobileOperatingSystem() === 'Android'"
              class="column is-half">
              <a
                :href="mobileLinks.appHomePageGoogleLink"
                class="is-block"><img
                  src="/img/download-google-play.png"
                  class="is-block"
                  alt="Télécharger sur Google Play"></a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div v-else></div>
</template>

<script>
import { DefaultValues } from '@/mixins'
export default {
  name: 'MobileResponsiveOverlay',
  mixins: [DefaultValues],
  data () {
    return {
      displayInsuficientResolutionPage: true,
      hideOverlay: false
    }
  },
  computed: {
    /**
     * Get device store link. If mobile device is nor android nor ios, returns google play store by default.
     * @returns {string}
     */
    getStoreLink () {
      if (this.getMobileOperatingSystem() === 'iOS') {
        return this.mobileLinks.appHomePageIosLink
      } else if (this.getMobileOperatingSystem() === 'Android') {
        return this.mobileLinks.appHomePageGoogleLink
      } else {
        return this.mobileLinks.appHomePageGoogleLink
      }
    },
    currentRouteName () {
      return this.$route.name
    }
  },
  watch: {
    '$route' (to, from) {
      if (to.name === 'ResetPassword' || from.name === 'ResetPassword') {
        this.hideOverlay = true
      } else {
        this.hideOverlay = false
      }
    }
  },
  created () {
    if (this.getMobileOperatingSystem()) {
      this.displayInsuficientResolutionPage = false
      if (this.currentRouteName === 'ResetPassword') {
        this.hideOverlay = true
      }
    }
  },
  methods: {
    /**
     * Get mobile operating system based on user agent.
     * @returns {string|null}
     */
    getMobileOperatingSystem () {
      const userAgent = navigator.userAgent || navigator.vendor || window.opera
      // Windows Phone must come first because its UA also contains "Android"
      if (/windows phone/i.test(userAgent)) {
        return null
      }
      if (/android/i.test(userAgent)) {
        return 'Android'
      }
      if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        return 'iOS'
      }
      return null
    }

  }
}
</script>
